<template>
<div class="modal-mask-pause background-rhythm">
    <div class="modal-wrapper-pause">
        <div class="modal-container-pause">

            <div class="modal-header-pause tamanhotitle">
                <slot name="header">
                     {{$t('games.shared.waiting')}}
                </slot>
            </div>
            <div class="modal-body-wait">
                <slot name="body">
                    <div class="containerwatin-melody">
                      <div class="dash uno"></div>
                      <div class="dash dos"></div>
                      <div class="dash tres"></div>
                      <div class="dash cuatro"></div>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "WaitModal",
    created() {},
    data() {
        return {};
    },
    props: {},
    methods: {},
};
</script>

<style>



</style>
